import React, { useState } from 'react';
import './SignUpForm.css';
import { CheckCircle, Sparkles } from 'lucide-react';
import { toast } from 'react-toastify';

function SignUpForm() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim() || !email.includes('@')) {
      toast.error('Please enter a valid email');
      return;
    }

    setIsSubmitting(true);

    try {
      // Web3Forms integration
      const formData = new FormData();
      formData.append('access_key', '91bfa044-ccc8-44e7-add0-2e9ea7ba1370'); // ← Replace with your actual key
      formData.append('email', email);
      formData.append('subject', 'New Beta Signup - Repost');
      formData.append('from_name', 'Repost Beta Signup');

      // Optional: Add metadata for tracking
      formData.append('source', 'Landing Page');
      formData.append('timestamp', new Date().toISOString());

      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setIsSuccess(true);
        setEmail(''); // Clear form
        toast.success('Welcome! Check your email for next steps.');
      } else {
        throw new Error(data.message || 'Failed to join waitlist');
      }
    } catch (error) {
      console.error('Signup error:', error);
      toast.error('Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSuccess) {
    return (
      <section className='signup-section' id='signup'>
        <div className='signup-container'>
          <div className='success-card'>
            <div className='success-icon'>
              <CheckCircle size={48} />
            </div>
            <h2 className='success-title'>You're on the list 🎯</h2>
            <p className='success-subtitle'>
              We'll send your early access invite within 24 hours.
            </p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className='signup-section' id='signup'>
      <div className='signup-container'>
        <div className='signup-content'>
          <div className='signup-badge'>
            <Sparkles size={16} />
            <span>⚡ 25 Beta Spots • First Come First Served</span>
          </div>

          <h2 className='signup-title'>
            Join the Private Beta (25 Spots Only)
          </h2>
          <p className='signup-subtitle'>
            We're giving 25 newsletter creators lifetime free access to test and
            shape this tool. In exchange: honest feedback as we build. First
            come, first served.
          </p>

          <form className='signup-form-inline' onSubmit={handleSubmit}>
            <input
              type='email'
              className='email-input'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder='Your email'
              required
            />
            <button
              type='submit'
              className='submit-btn'
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Apply for Beta'}
            </button>
          </form>

          <div className='trust-badges'>
            <span>✓ Lifetime Pro access</span>
            <span>✓ Shape the product</span>
            <span>✓ Priority support</span>
          </div>

          <div className='beta-criteria'>
            <p className='criteria-title'>What we're looking for:</p>
            <ul className='criteria-list'>
              <li>
                Newsletter creators repurposing to LinkedIn/X/Insta weekly
              </li>
              <li>Spending 2+ hours manually creating social posts</li>
              <li>Willing to give candid feedback</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SignUpForm;
